module.exports = __webpack_public_path__ + "static/media/sc43.38d74333.mp4";